// Chunky 3D pressable button — the signature Duolingo control.
// Colors flow through CSS vars (--btn-face / --btn-edge / --btn-text); the
// press-down + shadow-collapse on :active lives in `.se-btn3d` (index.css).
//
// Variants: primary (green) · ink (dark) · ghost (white outline) ·
//           speak (blue) · danger (red) · minimal (text-only, no 3D edge)

const VARIANTS = {
  primary: { face: "var(--feather)",  edge: "var(--feather-dark)", text: "#ffffff" },
  ink:     { face: "var(--ink-900)",  edge: "var(--ink-950)",      text: "#ffffff" },
  ghost:   { face: "#ffffff",          edge: "var(--border-3)",     text: "var(--ink-600)", border: "2px solid var(--border-2)" },
  speak:   { face: "var(--sky)",       edge: "var(--sky-dark)",     text: "#ffffff" },
  danger:  { face: "var(--berry)",     edge: "var(--berry-dark)",   text: "#ffffff" },
  xp:      { face: "var(--xp)",        edge: "var(--xp-dark)",      text: "var(--ink-900)" },
};

const SIZES = {
  sm: { padding: "9px 14px",  fontSize: 13 },
  md: { padding: "12px 18px", fontSize: 14 },
  lg: { padding: "15px 26px", fontSize: 16 },
};

export default function Button({
  children,
  variant = "primary",
  icon,
  iconLeft,
  iconRight,
  onClick,
  size = "md",
  block = false,
  as: Tag = "button",
  className = "",
  style,
  disabled,
  ...rest
}) {
  // minimal = plain text button, no 3D edge
  if (variant === "minimal") {
    return (
      <Tag
        onClick={onClick}
        disabled={Tag === "button" ? disabled : undefined}
        aria-disabled={disabled || undefined}
        className={`se-btn ${className}`.trim()}
        style={{
          display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
          background: "transparent", color: "var(--fg-2)", border: "none",
          fontFamily: "var(--font-body)", fontWeight: 800, lineHeight: 1, cursor: "pointer",
          borderRadius: 12, textDecoration: "none",
          width: block ? "100%" : undefined,
          ...SIZES[size], ...style,
        }}
        {...rest}
      >
        {iconLeft || icon}{children}{iconRight}
      </Tag>
    );
  }

  const v = VARIANTS[variant] || VARIANTS.primary;
  return (
    <Tag
      onClick={onClick}
      disabled={Tag === "button" ? disabled : undefined}
      aria-disabled={disabled || undefined}
      className={`se-btn3d ${className}`.trim()}
      style={{
        "--btn-face": v.face,
        "--btn-edge": v.edge,
        "--btn-text": v.text,
        ...(v.border ? { border: v.border } : null),
        width: block ? "100%" : undefined,
        ...SIZES[size],
        ...style,
      }}
      {...rest}
    >
      {iconLeft || icon}
      {children}
      {iconRight}
    </Tag>
  );
}
